import YLink from './src/main'

YLink.install = function(Vue) {
  Vue.component(YLink.name, YLink)
}

export default YLink
